/**
 * Função para remover formatação, pontuação e caracteres especiais
 * @param value - Número com formatação/pontuação
 * @return Número sem formatação
 * */
export const integer = (value) =>
    value && value.replace(/\D/g, '');
